import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios"; // You can use Axios or Fetch for API calls
import MILogo from "../../images/MI-Image.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { formatCurrency } from "../../utlis/utlis";

const SuccessPage = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const {
    code,
    description,
    amount,
    currencyCode,
    serviceCharges,
    invoiceNumber,
  } = location.state || {};

  const handleBackToMerchantClick = async () => {
    setLoading(true);

    try {
      // Make an API call to the backend to get the URL and JSON response
      const response = await axios.get(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/payments/backtomerchant`,
        {
          params: {
            invoiceNo: invoiceNumber, // Send invoiceNo as a query parameter
          },
          headers: {
            Authorization: `Bearer `,
          },
        }
      );

      // Extract data from the response
      const {
        backtoMerchantUrl,
        merchantCode,
        invoiceNo,
        currency,
        amount,
        paymentChannel,
        paymentStatus,
        responseCode,
      } = response.data;

      // Create a form and append hidden input fields for each parameter
      const form = document.createElement("form");
      form.method = "POST";
      form.action = backtoMerchantUrl;

      const data = {
        merchantCode,
        invoiceNo,
        currency,
        amount,
        paymentChannel,
        paymentStatus,
        responseCode,
      };

      // Create hidden input fields for each piece of data
      Object.keys(data).forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
      });

      // Append the form to the body and submit it
      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Error redirecting to merchant:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container mt-5">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <img
            src={MILogo}
            alt="Logo"
            className="me-2" // Bootstrap class for margin-right
            style={{
              objectFit: "cover",
            }}
          />
        </div>
      </div>

      {/* Amount Section */}
      <div className="mt-3">
        <h5 className="text-primary m-0">Pay for Myanma Insurance</h5>

        <div className="table-responsive">
          <table className="table" style={{ fontSize: "16px", width: "auto" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    width: "55%",
                    fontWeight: "bold",
                  }}
                  className="text-start"
                >
                  Total Amount :
                </td>
                <td className="text-end" style={{ fontWeight: "bold" }}>
                  {formatCurrency(Number(amount) + Number(serviceCharges))}
                </td>
              </tr>
              <tr>
                <td style={{ width: "55%" }} className="text-start">
                  Transaction Amount :
                </td>
                <td className="text-end">{formatCurrency(amount)}</td>
              </tr>
              <tr>
                <td style={{ width: "55%" }} className="text-start">
                  Service Fee :
                </td>
                <td className="text-end">{formatCurrency(serviceCharges)}</td>
              </tr>
              <tr>
                <td style={{ width: "40%" }} className="text-start">
                  Invoice No. :
                </td>
                <td className="text-end">{invoiceNumber}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* QR Payment Section */}
      <div className="mt-4">
        <div className="text-success d-flex justify-content-center align-items-center mt-3">
          <h3>Transaction is successful.</h3>
        </div>
      </div>

      {/* Instructions Section */}
      <div className="mt-4 text-center">
        <p>Save invoice number {invoiceNumber} for future reference.</p>
        <p>
          For any additional queries or help, please contact{" "}
          <u>it-support@thuriyaacetechnology.com</u>
        </p>
      </div>

      {/* Save QR Button */}
      <div className="text-center mt-5 mb-5">
        <button
          className="btn btn-primary"
          onClick={handleBackToMerchantClick}
          disabled={loading} // Disable the button while the API call is in progress
        >
          {loading ? "Redirecting..." : "BACK TO MERCHANT"}
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;
